<template>
    <sui-segment-group style="max-width: 700px; margin: auto" raised>
        <sui-segment inverted style="text-align: center; font-size: 18px"
            >Enviar mensaje</sui-segment
        >

        <sui-segment style="padding: 10px">
            <sui-form>
                <sui-form-field>
                    <sui-label>Número telefónico</sui-label>
                    <div class="ui input">
                        <input
                            type="tel"
                            placeholder="+52 33 3333 3333"
                            v-model="messageForm.number"
                        />
                    </div>
                </sui-form-field>
                <sui-form-field>
                    <sui-label>Mensaje</sui-label>
                    <textarea
                        v-model="messageForm.message"
                        cols="30"
                        rows="2"
                        placeholder="Escribe aqui el mensaje"
                    ></textarea>
                </sui-form-field>
            </sui-form>
        </sui-segment>
        <sui-segment>
            <sui-message error>
                <template v-for="error of errorPrompts">
                    <sui-message-item>{{ error }}</sui-message-item>
                </template>
            </sui-message>
            <sui-button
                @click="sendMessage()"
                positive
                :class="{ loading: sending }"
            >
                Enviar mensaje
            </sui-button>
        </sui-segment>
    </sui-segment-group>
</template>

<script setup>
    import { ref, reactive, computed, onBeforeMount, watch } from "vue";
    import Api from "../../api/Api.js";
    import Util from "../../../Util.js";
    import { useToast } from "vue-toastification";
    import { useRouter } from "vue-router";
    import Validator from "../../api/Validator";
    // import { SuiCheckbox } from "vue-fomantic-ui";
    import { decryptData } from "../../../Util";

    const clients = ref(null);
    const products = ref([]);
    const segments = ref([]);
    const range_prices = ref([]);
    const item_types = ref([]);
    const suppliers = ref([]);
    const toast = useToast();
    const router = useRouter();
    const selectedClients = ref([]);
    const only_customers = ref(false);
    const sending = ref(false);
    const errorPrompts = ref(null);
    const onlyClients = ref(false);
    const adminType = decryptData(localStorage.getItem("adminType"));
    const userPermissions = decryptData(localStorage.getItem("permissions"));;

    const messageForm = reactive({
        number: "",
        message: "",
    });
    const emit = defineEmits(["createdPromotion"]);

    onBeforeMount(async () => {
        // const today = new Date();
        // const dateTo = new Date();
        //
        // dateTo.setDate(dateTo.getDate() + 7);
        // dateTo.setHours(23, 59, 0, 0);
        //
        // messageForm.date = [today, dateTo];
        // await getProducts();
        // await getClients();
        // await getSuppliers();
        // await getProductsTypes();
        // clients.value = clients.value.map((c) => ({
        //     ...c,
        //     label: c.business_name + (c.range_name ? " - " + c.range_name : ""),
        // }));
    });

    const sendMessage = async () => {
        var { valid, prompts } = Validator(
            {
                ...messageForm,
            },
            {
                number: {
                    label: "Numero telefónico",
                    rules: ["phone"],
                },
                message: {
                    label: "Mensaje",
                    rules: ["minLength[10]"],
                },
            }
        );
        errorPrompts.value = prompts;
        // if (messageForm.all_customers == 0 && !messageForm.customers.length)
        //     errorPrompts.value.push("Debes seleccionar al menos un cliente");
        // if (messageForm.all_customers == 2 && !messageForm.segments.length)
        //     errorPrompts.value.push("Debes seleccionar al menos un segmento");
        // if (messageForm.category == "1" && !messageForm.products.length)
        //     errorPrompts.value.push("Debes seleccionar al menos un producto");
        // if (messageForm.category == "2" && !messageForm.suppliers.length)
        //     errorPrompts.value.push("Debes seleccionar al menos una marca");
        // if (messageForm.category == "3" && !messageForm.item_types.length)
        //     errorPrompts.value.push("Debes seleccionar al menos un artículo");
        // if (messageForm.type == 2 && !messageForm.bonus_product_id)
        //     errorPrompts.value.push("Debes seleccionar un producto de bono");

        // const checkDate = new Date(messageForm.date[0]);
        // checkDate.setHours(0, 0, 0, 0);
        // const today = new Date();
        // today.setHours(0, 0, 0, 0);
        // if (checkDate < today) {
        //     errorPrompts.value.push(
        //         "La fecha de inicio no puede ser menor a la fecha actual"
        //     );
        //     valid = false;
        // }

        // const productList = messageForm.products.map((p) => p.product_id);
        // const suppliersList = messageForm.suppliers.map((p) => p.supplier_id);
        // const itemTypesList = messageForm.item_types.map((p) => p.type_id);
        // messageForm.only_customers = only_customers.value ? 1 : 0;
        // try {
        //     const res = await Api.checkPromotion(
        //         messageForm.category,
        //         productList,
        //         suppliersList,
        //         itemTypesList,
        //         messageForm.all_customers,
        //         messageForm.customers,
        //         messageForm.segments,
        //         messageForm.price_range
        //     );
        //
        //     if (res.error) {
        //         errorPrompts.value.push(res.message_client);
        //         valid = false;
        //     }
        //     if (res.data.length) {
        //         toast.warning(
        //             "Ya existe una promocion con alguno de los productos seleccionados."
        //         );
        //         errorPrompts.value.push(
        //             "Ya existe una promocion con alguno de los productos seleccionados."
        //         );
        //         valid = false;
        //     }
        // } catch (err) {
        //     errorPrompts.value.push(
        //         "Hubo un error al verificar los productos. (CIP-2)"
        //     );
        //     valid = false;
        // }
        //
        if (!valid) return;
        sending.value = true;

        Api.sendMessage(messageForm)
            .then((res) => {
                sending.value = false;
                if (res.error) {
                    return toast.error(res.message_client);
                }
                toast.success("Mensaje enviado con exito!");
                // return router.push({name:'Promotions'})
                emit("createdPromotion");
            })
            .catch((err) => {
                sending.value = false;
                console.log("ERROR", err);
                return toast.error(
                    "Hubo un error al crear la promoción. (CIP-1)"
                );
            });
    };
</script>

<style scoped>
    @import "vue-select/dist/vue-select.css";
</style>
